import React from 'react';
import { Section } from './ui/Section';
import { Testimonial } from './Testimonial';
import { Heart } from 'lucide-react';
import { Wildflower } from './botanical/Wildflower';
export function Testimonials3() {
  const testimonials = [{
    initials: 'NB',
    quote: 'Lo del insomnio me salvó. Tres años durmiendo mal y con la infusión de valeriana y el ritual nocturno empecé a dormir de corrido. No lo puedo creer.',
    author: 'NATALIA B.',
    location: 'POSADAS'
  }, {
    initials: 'CR',
    quote: 'Compré el Super Pack y valió cada peso. La Biblia del Hogar Natural la uso como referencia permanente. Está todo ahí.',
    author: 'CAROLINA R.',
    location: 'MENDOZA'
  }, {
    initials: 'JL',
    quote: 'Mi suegra tenía desconfianza pero le presté el tomo de respiración y ahora me pide que le compre el suyo propio.',
    author: 'JORGE L.',
    location: 'ROSARIO'
  }, {
    initials: 'MV',
    quote: 'El protocolo de emergencia nocturna fue lo primero que usé. Mi hijo con fiebre a las 2 AM y yo sabía exactamente qué hacer. Eso no tiene precio.',
    author: 'MÓNICA V.',
    location: 'BUENOS AIRES'
  }];
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-399">
      <Wildflower className="absolute bottom-10 -left-10 w-64 h-64 text-honey opacity-10 blur-[2px]" data-id="element-400" />

      <div className="text-center mb-10 relative z-10" data-id="element-401">
        <div className="inline-flex items-center justify-center gap-2 text-honey-dark font-bold tracking-widest uppercase mb-4" data-id="element-402">
          <Heart className="w-5 h-5 fill-current" data-id="element-403" />
          MÁS TESTIMONIOS
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto relative z-10" data-id="element-404">
        {testimonials.map((t, idx) => <Testimonial key={idx} {...t} data-id="element-405" />)}
      </div>
    </Section>;
}